import { useState } from 'react';
import { db } from '../../firebase/config';
import { collection, doc, setDoc, getDoc } from 'firebase/firestore';
import * as Icons from 'lucide-react';
import toast from 'react-hot-toast';

export default function ImportData() {
  const [importing, setImporting] = useState(false);
  const [stats, setStats] = useState({
    total: 0,
    new: 0,
    existing: 0,
    errors: 0
  });

  const importCustomer = async (customer) => {
    try {
      // Ellenőrizzük, hogy létezik-e már az ügyfél
      const customerRef = doc(db, 'customers', customer.customerId);
      const customerDoc = await getDoc(customerRef);

      if (customerDoc.exists()) {
        return 'existing';
      }

      // Dátumok konvertálása Firestore Timestamp-pé
      const createdAt = new Date(customer.createdAt);
      const updatedAt = new Date(customer.updatedAt);

      // Új ügyfél mentése
      await setDoc(customerRef, {
        ...customer,
        createdAt: createdAt,
        updatedAt: updatedAt
      });

      return 'new';
    } catch (error) {
      console.error('Error importing customer:', error);
      return 'error';
    }
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setImporting(true);
    setStats({
      total: 0,
      new: 0,
      existing: 0,
      errors: 0
    });

    try {
      const content = await file.text();
      const data = JSON.parse(content);
      
      if (!data.customers || !Array.isArray(data.customers)) {
        throw new Error('Invalid file format');
      }

      const total = data.customers.length;
      let newCount = 0;
      let existingCount = 0;
      let errorCount = 0;

      // Batch-ekben dolgozzuk fel az ügyfeleket
      const batchSize = 10;
      for (let i = 0; i < data.customers.length; i += batchSize) {
        const batch = data.customers.slice(i, i + batchSize);
        
        const results = await Promise.all(
          batch.map(customer => importCustomer(customer))
        );

        results.forEach(result => {
          if (result === 'new') newCount++;
          else if (result === 'existing') existingCount++;
          else if (result === 'error') errorCount++;
        });

        // Frissítjük a statisztikát
        setStats({
          total,
          new: newCount,
          existing: existingCount,
          errors: errorCount
        });
      }

      toast.success(`Importálás befejezve! ${newCount} új ügyfél importálva`);
    } catch (error) {
      console.error('Import error:', error);
      toast.error('Hiba történt az importálás során');
    } finally {
      setImporting(false);
    }
  };

  return (
    <div className="p-6">
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          JSON fájl kiválasztása
        </label>
        <input
          type="file"
          accept=".json"
          onChange={handleFileUpload}
          disabled={importing}
          className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
        />
      </div>

      {importing && (
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <Icons.Loader2 className="h-4 w-4 animate-spin" />
          Importálás folyamatban...
        </div>
      )}

      {stats.total > 0 && (
        <div className="mt-4 space-y-2 text-sm">
          <div className="flex justify-between py-2 border-b">
            <span>Összes rekord:</span>
            <span className="font-medium">{stats.total}</span>
          </div>
          <div className="flex justify-between py-2 border-b">
            <span>Új ügyfelek:</span>
            <span className="font-medium text-green-600">{stats.new}</span>
          </div>
          <div className="flex justify-between py-2 border-b">
            <span>Már létező ügyfelek:</span>
            <span className="font-medium text-gray-600">{stats.existing}</span>
          </div>
          {stats.errors > 0 && (
            <div className="flex justify-between py-2 border-b">
              <span>Hibák:</span>
              <span className="font-medium text-red-600">{stats.errors}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
} 